module.exports = __webpack_public_path__ + "img/headhunter.5bc72fe5.svg";